import { render, staticRenderFns } from "./vtex_settings.vue?vue&type=template&id=864ed596"
import script from "./vtex_settings.vue?vue&type=script&lang=js"
export * from "./vtex_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports